// extracted by mini-css-extract-plugin
export var chevronIcon = "_bt-2";
export var teamName = "_bt-1";
export var teamSwitcherButton = "_bt-0";